module.exports = __webpack_public_path__ + "media/images/webpage/logo/icot-logo-dc1fedb1d7f192159933d6de53ad267e.svg";